const initialFtdRestrictionsState = {
  ftdCount: null,
  minFtdAmount: null,
};

const initialWithdrawalLimitsState = {
  min: null,
  max: null,
};

const initialFtdRestrictions = {
  isBusy: false,
  initialRestrictions: initialFtdRestrictionsState,
  changedRestrictions: initialFtdRestrictionsState,
};

const initialWithdrawalLimits = {
  isBusy: false,
  initialLimits: initialWithdrawalLimitsState,
};

const initialPaymentMethods = {
  ftdRestrictions: initialFtdRestrictions,
  withdrawalLimits: initialWithdrawalLimits,
};

export default initialPaymentMethods;
